import { MobileDeviceWidth } from './constants'

const isMobile = () => {
  if (typeof window === 'undefined') return false
  return window.innerWidth <= MobileDeviceWidth
}

export default isMobile
